import {
  useAppShellChatActions,
  useAppShellChatModel,
  useAppShellChatPersistence,
  useAppShellChatRouteSync,
} from '@/features/chat/appShell'
import { useBackendChatSync } from '@/features/chat/appShell/useBackendChatSync'

/**
 * Chat + home thread routing + rail messaging + persistence for the app shell.
 * Composed from `appShell/*` hooks (Phase B) — public API unchanged.
 */
export function useAppShellChat() {
  const m = useAppShellChatModel()
  useAppShellChatRouteSync(m)
  useBackendChatSync(m)
  useAppShellChatPersistence(m)
  const {
    handleRenameThread,
    handleThreadMenuAction,
    handleAccountMenuAction,
    closeThreadShare,
    handleUpdateThreadMembers,
    mainLayoutProps,
  } = useAppShellChatActions(m)

  return {
    location: m.location,
    navigate: m.navigate,
    activePrimaryKey: m.activePrimaryKey,
    homeView: m.homeView,
    setHomeView: m.setHomeView,
    threads: m.navThreads,
    displayThreadId: m.displayThreadId,
    setSelectedThreadId: m.setSelectedThreadId,
    pinnedThreadIdsForNav: m.pinnedThreadIdsForNav,
    handleThreadMenuAction,
    handleRenameThread,
    handleAccountMenuAction,
    threadShareThread: m.threadShareThread,
    closeThreadShare,
    handleUpdateThreadMembers,
    mainLayoutProps,
  }
}
